export const PageContent = ({ children, ...props }) => {
  return (
    <div id="page-content" {...props}>
      {children}
    </div>
  )
}